import { Link } from "react-router-dom";
import { CategoryBadge } from "@/components/primitives";
import { articlePath, articleCat, formatRelativeDate } from "@/lib/readoo";

export function UpdatedBadge({ id }) {
  return (
    <span data-testid={`updated-badge-${id}`} className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-brand">
      <span className="w-1.5 h-1.5 rounded-full bg-brand" aria-hidden="true" /> Aggiornato
    </span>
  );
}

export function NewsCard({ article, compact = false }) {
  const a = article;
  return (
    <Link
      to={articlePath(a)}
      data-testid={`news-card-${a.article_id}`}
      className="group flex flex-col justify-between gap-3 bg-surfaceSecondary hover:bg-surfaceTertiary/50 border border-hair hover:border-hairStrong rounded-xl p-5 transition-colors duration-200"
    >
      <div className="flex flex-col gap-2.5">
        <CategoryBadge category={articleCat(a)} className="self-start" />
        <h3 className="font-serif text-[1.25rem] font-semibold leading-snug text-onSurface group-hover:text-brand transition-colors line-clamp-3">
          {a.title}
        </h3>
        {!compact && a.summary && (
          <p className="text-sm text-subtle leading-relaxed line-clamp-2">{a.summary}</p>
        )}
      </div>
      <div className="flex items-center justify-end gap-2 pt-2.5 border-t border-hair/60 text-[11px] font-mono text-subtle">
        {a.updates?.length > 0 && <UpdatedBadge id={a.article_id} />}
        <span>{formatRelativeDate(a.published_at)}</span>
      </div>
    </Link>
  );
}

export function HeroCard({ article }) {
  const a = article;
  if (!a) return null;
  return (
    <Link
      to={articlePath(a)}
      data-testid={`hero-card-${a.article_id}`}
      className="group block bg-surfaceSecondary border border-hair hover:border-brand/30 rounded-2xl p-6 sm:p-8 transition-colors duration-200"
    >
      <div className="flex items-center gap-3 mb-4">
        <CategoryBadge category={articleCat(a)} />
        {a.updates?.length > 0 && <UpdatedBadge id={a.article_id} />}
        <span className="text-[11px] font-mono text-subtle">{formatRelativeDate(a.published_at)}</span>
      </div>
      <h2 className="font-serif text-2xl sm:text-3xl lg:text-[2.5rem] font-semibold leading-tight text-onSurface group-hover:text-brand transition-colors">
        {a.title}
      </h2>
      {a.summary && (
        <p className="mt-4 text-base sm:text-lg text-onSurfaceSecondary/90 leading-relaxed line-clamp-3">{a.summary}</p>
      )}
    </Link>
  );
}
